<div
  class="quiz-result-text"
  [innerHTML]="html"
  (click)="onTextClick($event)"
></div>
